/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100DeviceMeasurementException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100UnauthorizedException,
  LatestZeroMeasurementDto,
  RunMeasurementRequestDto,
  RunningMeasurementResponseDto,
} from '../models/index';
import {
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100DeviceMeasurementExceptionFromJSON,
    ErrorResponseOfPtw100DeviceMeasurementExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    LatestZeroMeasurementDtoFromJSON,
    LatestZeroMeasurementDtoToJSON,
    RunMeasurementRequestDtoFromJSON,
    RunMeasurementRequestDtoToJSON,
    RunningMeasurementResponseDtoFromJSON,
    RunningMeasurementResponseDtoToJSON,
} from '../models/index';

export interface GetLatestZeroMeasurementRequest {
    arrayId: string;
    detectorInterfaceId: string;
}

export interface RunZeroMeasurementRequest {
    runMeasurementRequestDto?: RunMeasurementRequestDto;
}

export interface StopZeroMeasurementRequest {
    measurementId: string;
}

/**
 * 
 */
export class ZeroMeasurementApi extends runtime.BaseAPI {

    /**
     * Provides basic information about the latest zero measurement of a device combination (array + detector interface).
     */
    async getLatestZeroMeasurementRaw(requestParameters: GetLatestZeroMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['arrayId'] == null) {
            throw new runtime.RequiredError(
                'arrayId',
                'Required parameter "arrayId" was null or undefined when calling getLatestZeroMeasurement().'
            );
        }


        if (requestParameters['detectorInterfaceId'] == null) {
            throw new runtime.RequiredError(
                'detectorInterfaceId',
                'Required parameter "detectorInterfaceId" was null or undefined when calling getLatestZeroMeasurement().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/zero-measurement/latest/{arrayId}/{detectorInterfaceId}`.replace(`{${"arrayId"}}`, encodeURIComponent(String(requestParameters['arrayId']))).replace(`{${"detectorInterfaceId"}}`, encodeURIComponent(String(requestParameters['detectorInterfaceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => LatestZeroMeasurementDtoFromJSON(jsonValue), "LatestZeroMeasurementDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => LatestZeroMeasurementDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Provides basic information about the latest zero measurement of a device combination (array + detector interface).
     */
     async getLatestZeroMeasurement(requestParameters: GetLatestZeroMeasurementRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<ZeroMeasurementApi['getLatestZeroMeasurementRaw']>>, LatestZeroMeasurementDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = LatestZeroMeasurementDto;

         const response = this.getLatestZeroMeasurementRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Starts a zero measurement run for the specified request.
     */
    async runZeroMeasurementRaw(requestParameters: RunZeroMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/zero-measurement/run-measurement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RunMeasurementRequestDtoToJSON(requestParameters['runMeasurementRequestDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => RunningMeasurementResponseDtoFromJSON(jsonValue), "RunningMeasurementResponseDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 422: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100DeviceMeasurementExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100DeviceMeasurementException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => RunningMeasurementResponseDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Starts a zero measurement run for the specified request.
     */
     async runZeroMeasurement(requestParameters: RunZeroMeasurementRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<ZeroMeasurementApi['runZeroMeasurementRaw']>>, RunningMeasurementResponseDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = RunningMeasurementResponseDto;

         const response = this.runZeroMeasurementRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Cancels a running zero measurement for the specified measurement ID.
     */
    async stopZeroMeasurementRaw(requestParameters: StopZeroMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['measurementId'] == null) {
            throw new runtime.RequiredError(
                'measurementId',
                'Required parameter "measurementId" was null or undefined when calling stopZeroMeasurement().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/zero-measurement/{measurementId}/cancel`.replace(`{${"measurementId"}}`, encodeURIComponent(String(requestParameters['measurementId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Cancels a running zero measurement for the specified measurement ID.
     */
     async stopZeroMeasurement(requestParameters: StopZeroMeasurementRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<ZeroMeasurementApi['stopZeroMeasurementRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.stopZeroMeasurementRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
